export default __webpack_public_path__ + "static/media/football_bg_placeholder.fd0ebd7a.jpg";